import { AdvancedFilterButton } from '@/components/common/AdvancedFilter';
import { PageHeader } from '@/components/layout/PageHeader';

interface LeaveApplicationListHeaderProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  filterOpen: boolean;
  onFilterToggle: () => void;
  activeFilterCount: number;
}

export function LeaveApplicationListHeader({
  searchText,
  onSearchChange,
  filterOpen,
  onFilterToggle,
  activeFilterCount,
}: LeaveApplicationListHeaderProps) {
  return (
    <PageHeader
      title="Leave Applications"
      search={{
        value: searchText,
        onChange: onSearchChange,
        placeholder: 'ID, AM, ZM Name, Thana',
      }}
      actions={
        <AdvancedFilterButton
          isOpen={filterOpen}
          activeCount={activeFilterCount}
          onClick={onFilterToggle}
        />
      }
    />
  );
}
